import React from 'react'
import { Trans, withTranslation, WithTranslation } from 'react-i18next'
import Flex from 'typescript-styled-flex'
import { FiCalendar, FiFileText, FiUser } from 'react-icons/fi'
import Scrollbars from 'react-custom-scrollbars'
import { FaFileInvoiceDollar } from 'react-icons/fa'
import {
  EventRegistration,
  EventStatus,
  ICompany,
  IEvent,
  IGuestInfo,
} from '../../../models/Event'
import {
  BBTab,
  BBTabList,
  BBTabPanel,
  BBTabs,
} from '../../../components/Template/Tabs'
import { Form } from '../../../components/FormBuilder'
import { FeedingType, PrepaidType } from '../../../models/Object'
import Modal from '../../../components/Calendar/ReservationModal/Modal'
import BookingBar from '../../../components/IntegrationBar/BookingBar'
import IcalendarBar from '../../../components/IntegrationBar/IcalendarBar'
import PremiumBar from '../../../components/PremiumBar'
import { Desktop, Mobile } from '../../../components/MediaQuery'
import {
  ServicesModalCreate,
  ServicesModalUpdate,
} from '../../BookingCalendar/ReservationModal'
import TemplateSendModal from '../../BookingCalendar/ReservationModal/TemplateSendModal'
import { IWithSize } from '../../BookingCalendar/Calendar/Calendar'
import { withSize } from '../../../hooks/useSize'
import OtherTab from './OtherTab'
import GuestsTab from './GuestsTab'
import ReservationTab from './ReservationTab'
import { withIsDesktop } from './withIsDesktop'
import InvoiceTab from './InvoiceTab'
import BBEngineBar from '../../../components/IntegrationBar/BBEngineBar'
import AirbnbBar from '../../../components/IntegrationBar/AirbnbBar'
import { Mixpanel } from '../../../utils/Mixpanel'
import { LicenseType } from '../../../models/License'

function Scroll(props) {
  return (
    <Scrollbars {...props} hideTracksWhenNotNeeded={true} autoHide={false} />
  )
}

class CreateReservation extends React.Component<
  ICreateReservationProps &
    ICreateReservationDispatch &
    IWithSize &
    WithTranslation & { isDekstop: boolean } & IWithSize,
  { showPhoneError: boolean }
> {
  private guestScroll: React.RefObject<Scrollbars> | null = null

  public constructor(props) {
    super(props)
    this.state = {
      showPhoneError: false,
    }
    this.guestScroll = React.createRef()
  }

  private createProvenance = option => {
    this.props.addProvenance(option.value)
  }

  public onselect = index => {
    this.props.closeTooltips()

    setTimeout(() => this.props.selectTab(index), 50)
  }

  componentDidUpdate(
    prevProps: Readonly<
      ICreateReservationProps &
        ICreateReservationDispatch &
        IWithSize &
        WithTranslation & { isDekstop: boolean }
    >,
    prevState: Readonly<{ showPhoneError: boolean }>,
    snapshot?: any,
  ) {
    if (prevProps.id !== this.props.id) {
      this.props.initialize(this.props.initialValues)
    }
  }

  public shouldComponentUpdate(
    nextProps: Readonly<
      ICreateReservationProps &
        ICreateReservationDispatch &
        WithTranslation &
        IWithSize
    >,
    nextState: Readonly<{ showPhoneError: boolean }>,
  ): boolean {
    if (
      nextProps.roomSize !== this.props.roomSize ||
      nextProps.formatDate !== this.props.formatDate ||
      nextProps.timeTo !== this.props.timeTo ||
      nextProps.timeFrom !== this.props.timeFrom ||
      nextProps.selectedTab !== this.props.selectedTab ||
      nextProps.hideUserData !== this.props.hideUserData ||
      nextProps.premium !== this.props.premium ||
      nextProps.isDesktop !== this.props.isDesktop ||
      nextProps.allowReservationEdit !== this.props.allowReservationEdit ||
      nextState.showPhoneError !== this.state.showPhoneError ||
      nextProps.isSaving !== this.props.isSaving ||
      nextProps.allowConfig !== this.props.allowConfig ||
      nextProps.allowFvat !== this.props.allowFvat ||
      nextProps.allowTemplates !== this.props.allowTemplates ||
      nextProps.size !== this.props.size ||
      nextProps.id !== this.props.id ||
      nextProps.invoice !== this.props.invoice ||
      nextProps.licenseValid !== this.props.licenseValid ||
      nextProps.initialValues.roomId !== this.props.initialValues.roomId ||
      nextProps.initialValues.reservationStatus !==
        this.props.initialValues.reservationStatus
    ) {
      return true
    }
    return false
  }

  public setPhoneError = toggle =>
    this.setState(state => ({ ...state, showPhoneError: toggle }))

  public render(): React.ReactNode {
    const {
      isDesktop,
      initialValues,
      booking,
      iCalendar,
      toggleProvenancesModal,
      type,
      change,
      changeChildren,
      changeDates,
      timeFrom,
      size,
      fromWebsite,
      groupReservations,
      timeTo,
      roomSize,
      airbnb,
      id,
      formatDate,
      calculate,
      refresh,
      toggleServicesModal,
      bookingPrice,
      price,
      isSaving,
      firePricingError,
      allowFvat,
      allowConfig,
      allowTemplates,
      allowReservationEdit,
      hideUserData,
      licenseType,
      isNewPremiumPriceGroup
    } = this.props

    const height =
      120 +
      (!this.props.premium ? 120 * size : 0) + //Premium bar
      (booking && booking !== '0' ? 48 * size : 0) + //Booking calendar bar
      (airbnb && airbnb !== '0' ? 48 * size : 0) + //Booking calendar bar
      (iCalendar && iCalendar !== '0' ? 48 * size : 0) + //Icalendar bar
      (fromWebsite &&
      fromWebsite !== '0' &&
      groupReservations &&
      groupReservations.length > 1
        ? 48 * size
        : 0) + //Icalendar bar
      21 * size //Labels

    return (
      <Flex>
        <Form onSubmit={null} row={true}>
          <BBTabs
            forceRenderTabPanel={true}
            selectedIndex={this.props.selectedTab}
            onSelect={this.onselect}
          >
            <BBTabList
              style={{
                fontSize: `${16 * size}px`,
                paddingTop: `${20 * size}px`,
              }}
            >
              <BBTab
                data-cy={'reservation-form-tab-button-1'}
                onClick={() => {
                  Mixpanel.track('Reservation Tab Used', {
                    'Reservation ID': Number(id),
                  })
                }}
              >
                <Flex
                  full={true}
                  alignCenter={true}
                  justifyCenter={true}
                  row={isDesktop}
                  column={!isDesktop}
                >
                  <FiCalendar style={isDesktop ? { marginRight: '5px' } : {}} />{' '}
                  {isDesktop && <Trans i18nKey={'reservation_page_booking'} />}
                </Flex>
              </BBTab>
              <BBTab
                data-cy={'reservation-form-tab-button-2'}
                onClick={() => {
                  Mixpanel.track('Client Tab Used', {
                    'Reservation ID': Number(id),
                  })
                  if ('gtag' in window) {
                    ;(window as any).gtag('event', 'conversion', {
                      send_to: 'AW-927657230/J_EhCO3twJADEI7aq7oD',
                    })
                  }
                }}
              >
                <Flex
                  full={true}
                  alignCenter={true}
                  justifyCenter={true}
                  row={isDesktop}
                  column={!isDesktop}
                >
                  <FiUser style={isDesktop ? { marginRight: '5px' } : {}} />{' '}
                  {isDesktop && <Trans i18nKey={'reservation_page_client'} />}
                </Flex>
              </BBTab>
              <BBTab
                data-cy={'reservation-form-tab-button-3'}
                onClick={() => {
                  Mixpanel.track('Details Tab Used', {
                    'Reservation ID': Number(id),
                  })
                }}
              >
                <Flex
                  full={true}
                  alignCenter={true}
                  justifyCenter={true}
                  row={isDesktop}
                  column={!isDesktop}
                >
                  <FiFileText style={isDesktop ? { marginRight: '5px' } : {}} />{' '}
                  {isDesktop && <Trans i18nKey={'reservation_page_details'} />}
                </Flex>
              </BBTab>
              <BBTab
                data-cy={'reservation-form-tab-button-4'}
                onClick={() => {
                  Mixpanel.track('Invoice Tab Used', {
                    'Reservation ID': Number(id),
                  })
                }}
              >
                <Flex
                  full={true}
                  alignCenter={true}
                  justifyCenter={true}
                  row={isDesktop}
                  column={!isDesktop}
                >
                  <FaFileInvoiceDollar
                    style={isDesktop ? { marginRight: '5px' } : {}}
                  />
                  {isDesktop && <Trans i18nKey={'z5020_main_menu_invoice'} />}
                </Flex>
              </BBTab>
            </BBTabList>
            {booking && booking !== '0' && (
              <BookingBar reservationId={booking} price={bookingPrice} />
            )}
            {airbnb && airbnb !== '0' && (
              <AirbnbBar reservationId={airbnb} price={price} />
            )}
            {iCalendar && iCalendar !== '0' && <IcalendarBar />}
            {fromWebsite &&
              fromWebsite !== '0' &&
              groupReservations &&
              groupReservations.length > 1 && (
                <BBEngineBar groupReservations={groupReservations} />
              )}
            <PremiumBar
              size={size}
              isWithShadow={true}
              margin={false}
              source="reservation"
            />
            <BBTabPanel forceRender={true} style={{ padding: '0px' }}>
              <Desktop>
                <Scroll style={{ minHeight: `calc(85vh - ${height}px)` }}>
                  <ReservationTab
                    airbnb={airbnb}
                    invoice={this.props.invoice}
                    change={change}
                    changeChildren={changeChildren}
                    changeDates={changeDates}
                    timeFrom={timeFrom}
                    timeTo={timeTo}
                    roomSize={roomSize}
                    initialValues={initialValues}
                    formatDate={formatDate}
                    type={type}
                    calculate={calculate}
                    refresh={refresh}
                    prepaidType={initialValues.prepaymentType}
                    toggleServicesModal={toggleServicesModal}
                    isSaving={isSaving}
                    id={id}
                    firePricingError={firePricingError}
                    allowConfig={allowConfig}
                    allowReservationEdit={allowReservationEdit}
                    isLite={isNewPremiumPriceGroup && licenseType?.licenseType === LicenseType.LICENSE_PREMIUM_LITE}
                  />
                </Scroll>
              </Desktop>
              <Mobile>
                <ReservationTab
                  invoice={this.props.invoice}
                  airbnb={airbnb}
                  change={change}
                  changeChildren={changeChildren}
                  changeDates={changeDates}
                  timeFrom={timeFrom}
                  timeTo={timeTo}
                  roomSize={roomSize}
                  initialValues={initialValues}
                  formatDate={formatDate}
                  type={type}
                  calculate={calculate}
                  refresh={refresh}
                  prepaidType={initialValues.prepaymentType}
                  toggleServicesModal={toggleServicesModal}
                  isSaving={isSaving}
                  firePricingError={firePricingError}
                  allowConfig={allowConfig}
                  allowReservationEdit={allowReservationEdit}
                  isLite={isNewPremiumPriceGroup && licenseType?.licenseType === LicenseType.LICENSE_PREMIUM_LITE}
                />
              </Mobile>
              {type === 'update' ? (
                <ServicesModalUpdate />
              ) : (
                <ServicesModalCreate />
              )}
            </BBTabPanel>

            <BBTabPanel forceRender={true} style={{ padding: '0px' }}>
              <Desktop>
                <Scrollbars
                  style={{ minHeight: `calc(85vh - ${height}px)` }}
                  ref={this.guestScroll}
                  hideTracksWhenNotNeeded={true}
                  autoHide={false}
                >
                  <GuestsTab
                    guestScroll={this.guestScroll}
                    setPhoneError={this.setPhoneError}
                    phoneError={this.state.showPhoneError}
                    initialValues={initialValues}
                    type={type}
                    isSaving={isSaving}
                    allowTemplates={allowTemplates}
                    firePricingError={firePricingError}
                    hideUserData={hideUserData}
                    isLite={isNewPremiumPriceGroup && licenseType?.licenseType === LicenseType.LICENSE_PREMIUM_LITE}
                  />
                </Scrollbars>
              </Desktop>
              <Mobile>
                <GuestsTab
                  setPhoneError={this.setPhoneError}
                  phoneError={this.state.showPhoneError}
                  initialValues={initialValues}
                  type={type}
                  isSaving={isSaving}
                  allowTemplates={allowTemplates}
                  firePricingError={firePricingError}
                  hideUserData={hideUserData}
                  isLite={isNewPremiumPriceGroup && licenseType?.licenseType === LicenseType.LICENSE_PREMIUM_LITE}
                />
              </Mobile>
            </BBTabPanel>

            <BBTabPanel forceRender={true} style={{ padding: '0px' }}>
              <Desktop>
                <Scroll style={{ minHeight: `calc(85vh - ${height}px)` }}>
                  <OtherTab
                    toggleProvenancesModal={toggleProvenancesModal}
                    createProvenance={this.createProvenance}
                    type={type}
                    allowReservationEdit={allowReservationEdit}
                    firePricingError={firePricingError}
                    isSaving={isSaving}
                    hideUserData={hideUserData}
                    isLite={isNewPremiumPriceGroup && licenseType?.licenseType === LicenseType.LICENSE_PREMIUM_LITE}
                  />
                </Scroll>
              </Desktop>
              <Mobile>
                <OtherTab
                  toggleProvenancesModal={toggleProvenancesModal}
                  createProvenance={this.createProvenance}
                  type={type}
                  isSaving={isSaving}
                  allowReservationEdit={allowReservationEdit}
                  firePricingError={firePricingError}
                  isLite={isNewPremiumPriceGroup && licenseType?.licenseType === LicenseType.LICENSE_PREMIUM_LITE}
                />
              </Mobile>
            </BBTabPanel>

            <BBTabPanel forceRender={true} style={{ padding: '0px' }}>
              <InvoiceTab allowFvat={allowFvat} activeLicense={licenseType}/>
            </BBTabPanel>
          </BBTabs>
          <Modal />
          <TemplateSendModal />
        </Form>
      </Flex>
    )
  }
}

export default withIsDesktop(withSize(withTranslation()(CreateReservation)))

export interface ICreateReservationProps {
  initialValues: ICreateReservationFormValues
  selectedTab: number
  groupReservations?: IEvent[]
  timeTo?: string
  timeFrom?: string
  roomSize?: any
  children?: any
  formatDate?: string
  type: 'create' | 'update'
  adultsCount?: number
  isDesktop?: boolean
  id?: string
  currentAdultsCount?: any
  booking?: string
  iCalendar?: string
  premium?: boolean
  bookingPrice?: string
  isSaving?: boolean
  lang?: string
  fromWebsite?: string
  airbnb?: string
  price?: string
  invoice?: any
  licenseValid?: any
  history?: any
  allowConfig?: boolean
  allowFvat?: boolean
  allowTemplates?: boolean
  allowReservationEdit?: boolean
  hideUserData?: boolean
  licenseType?: any
  isNewPremiumPriceGroup?: boolean
}

export interface ICreateReservationDispatch {
  toggleProvenancesModal?: (toggle?: boolean) => () => void
  addProvenance?: (name: string) => void
  toggleServicesModal?: (toggle: boolean) => () => void
  changeChildren?: (count: number) => void
  changeAdultsCount?: (count: number) => void
  changeDates?: (name: string, e: Date | number) => void
  calculate?: () => void
  selectTab?: (index) => void
  refresh?: () => void
  initialize?: any
  change?: any
  closeTooltips?: () => void
  toggleHideModal?: any
  firePricingError: () => void
}

export interface ICreateReservationFormValues {
  id?: any
  services?: IFormService[]
  withoutTax?: boolean
  createDate?: string
  priceType?: number
  daysCount?: number
  childrenCount?: number
  children?: any
  dateFrom?: Date
  payOnPlaceDate?: Date
  prepaymentType?: number
  dateTo?: Date
  timeFrom?: string
  timeTo?: string
  customColor?: string
  pricePerDay?: string
  setCustomColor?: boolean
  roomId?: string
  singleBeds?: number
  twinBeds?: number
  doorCode?: string
  note?: string
  adultsCount?: number
  endPrice?: string
  feeding?: FeedingType
  registration?: EventRegistration
  provenances?: string
  reservationStatus?: EventStatus
  additionalGuests?: IGuestInfo[]
  guest?: IGuestInfo
  company?: ICompany
  roomSize?: string
  prepaidType?: PrepaidType
  advancePaymentPrice?: string
  advancePriceDate?: Date
  advancePaymentType?: string
  timeToPayDays?: number
  timeToPayDate?: Date
  timeToWaitDays?: number
  timeToWaitDate?: Date
  deposit?: string
  payOnPlacePrice?: string
  localTax?: string
  payOnPlacePaymentType?: string
  pricePerPerson?: string
}

export interface IFormService {
  count: number
  id: number
  name: string
  price: string
  tax: number
  secondTax: string
}
